declare global {
  interface Window {
    APP_CONFIG: any;
  }
}

const getAppConfig = (key: string): string => {
  // Check if the backend script loaded at all
  if (!window.APP_CONFIG) {
    throw new Error("CRITICAL ERROR: Backend configuration (window.APP_CONFIG) failed to load. Please check the script tag in index.html.");
  }
  // Check if the specific key exists and is not empty
  if (!(key in window.APP_CONFIG) || window.APP_CONFIG[key] === "") {
    throw new Error(`CRITICAL ERROR: Missing required configuration key '${key}' in appsettings.json on the backend.`);
  }
  return window.APP_CONFIG[key];
};

export const AppConfig = {
  BASE_URL: getAppConfig("REACT_APP_BASE_URL"),
  AZURE_CLIENT_ID: getAppConfig("REACT_APP_AZURE_CLIENT_ID"),
  AZURE_AUTHORITY: getAppConfig("REACT_APP_AZURE_AUTHORITY"),
  AZURE_REDIRECT_URI: getAppConfig("REACT_APP_AZURE_REDIRECT_URI"),
  RECAPTCHA_SITE_KEY: getAppConfig("REACT_APP_RECAPTCHA_SITE_KEY"),
  MY_BASE_URL: getAppConfig("REACT_APP_MY_BASE_URL"),
  SENTRY_DSN: getAppConfig("SENTRY_DSN"),
  PRODUCTCODE: getAppConfig("REACT_APP_PRODUCTCODE"),
  TRIALPLANID: getAppConfig("REACT_APP_TRIALPLANID"),
  ALLOW_SUMMARY_REPORT: getAppConfig("REACT_APP_ALLOW_SUMMARY_REPORT") === "true",
  CLOUDFLARE_SITE_KEY: getAppConfig("REACT_APP_CLOUDFLARE_SITE_KEY"),
  CLOUDFLARE_CHECK: getAppConfig("REACT_APP_CLOUDFLARE_CHECK") === "true",
  ENABLE_INVOKE_AI: getAppConfig("REACT_APP_ENABLE_INVOKE_AI") === "true",
  LICENSING_BASE_URL: getAppConfig("REACT_APP_LICENSING_BASE_URL"),
};
